import { InputDropdownGroup } from '../../../common/LetterForms/InputDropdownGroup'
import { InputLabel, Link } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import { TextEditor } from '../../../common/LetterForms/TextEditor'

export const TemplateInput = ({
  control,
  options,
  selectFieldName,
  selectLabel,
  editUrl,
  ctaTitle,
  editorFieldName,
  editorLabel,
  isSmall = false,
  required = false,
  setValue,
}) => {
  return (
    <>
      {editorLabel && (
        <InputLabel
          style={{
            marginTop: '10px',
            marginBottom: '10px',
          }}
        >
          {editorLabel}
        </InputLabel>
      )}
      <InputDropdownGroup
        name={selectFieldName}
        control={control}
        label={selectLabel}
        options={options}
        setValue={(value) => setValue(editorFieldName, value)}
        noMargin
      />

      <Stack sx={{ mb: 8, mt: 3 }}>
        <TextEditor
          fieldName={editorFieldName}
          control={control}
          isSmall={isSmall}
          required={required}
        />
        <Link
          style={{
            marginTop: '10px',
          }}
          component={RouterLink}
          underline="hover"
          to={`/${editUrl}`}
        >
          {ctaTitle}
        </Link>
      </Stack>
    </>
  )
}
